<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<p class="first" style="text-align: center;">
	Diversion Books<br/>
	A Division of Diversion Publishing Corp.<br/>
	443 Park Avenue South, Suite 1008<br/>
	New York, NY 10016<br/>
<a href="http://www.DiversionBooks.com" target="_blank">www.DiversionBooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	Copyright © 1958 by Henry Kuttner<br/>
	All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
<p class="sectiontop" style="text-align: center;">
	This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.</p>
<p class="sectiontop" style="text-align: center;">
	For more information, email <a href="mailto:info@diversionbooks.com">info@diversionbooks.com</a></p>
<p class="sectiontop" style="text-align: center;">
	First Diversion Books edition<b> </b>August 2014<br/>
	ISBN: <span style="font-family: 'Liberation Serif', serif; font-size: 1em; line-height: 1.375; text-align: justify;">978-1-62681-380-9</span></p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h2 style="text-align: center;">
	More from Henry Kuttner</h2>
<p class="sectiontop" style="text-align: center;">
<span href="#/chap270022" title="Link target outside of Sample">The Time Trap<br/>
	Book of Iod<br/>
	Elak of Atlantis<br/>
	Prince Raynor<br/>
	Murder of Eleanor Pope<br/>
	Murder of a Mistress<br/>
	Murder of a Wife<br/>
	Murder of Ann Avery<br/>
	The Best of Henry Kuttner<br/>
	Robots Have No Tails<br/>
	Ahead of Time<br/>
	Earth’s Last Citadel<br/>
	Mask of Circe<br/>
	Man Drowning</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03a_copy.vue?0f5f98fe